import { DatePipe } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { TimeFormatPipe } from '../../../../../../../../shared/pipes/time-format.pipe';
import { MmrService } from '../../../../../../services/mmr.service';
import { ClaimDetailsPanelViewClaim, ClaimTrackerStep } from '../../../../../../types/mmr-claims.type';
import { TrackerCurrentStepComponent } from './components/tracker-current-step/tracker-current-step.component';
import { getDaysElapsed, StatusNameMappingPipe } from './repair-tracker-timeline.utils';

@Component({
  selector: 'app-repair-tracker-timeline',
  imports: [TimeFormatPipe, StatusNameMappingPipe, DatePipe, TrackerCurrentStepComponent],
  templateUrl: './repair-tracker-timeline.component.html',
  styleUrl: './repair-tracker-timeline.component.scss',
})
export class RepairTrackerTimelineComponent {
  claimType = input.required<'repair' | 'service'>();

  protected viewModel = computed(() => {
    const { claims } = this.mmrService.planClaimsDetails;

    const claim = claims.value()?.[this.claimType()] as ClaimDetailsPanelViewClaim;

    return {
      lastUpdated: claims.value()?.lastUpdated?.toTimeString(),
      claimTracker: claim?.claimTracker,
      claimType: this.claimType(),
      serviceOptionType: (claim?.serviceOptionType ?? '').toLowerCase(),
    };
  });

  get vm() {
    return this.viewModel();
  }

  constructor(private readonly mmrService: MmrService) {}

  isWarning(step: ClaimTrackerStep): boolean {
    return (
      (step.status === 'waiting_for_parts' && getDaysElapsed(step.statusChange) >= 5) ||
      step.status === 'remedial_work_required'
    );
  }
}
